import type { IconNode } from '../types';

/**
 * @name rugby
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTUuNyAyLjNjLS4yLS4yLS45LS40LTEuNy0uM2E0LjYgNC42IDAgMCAwLTMuNyA1LjdjLjMuMi45LjQgMS43LjNhNC42IDQuNiAwIDAgMCAzLjctNS43IiAvPgogIDxwYXRoIGQ9Ik0yMCAxMkg0IiAvPgogIDxyZWN0IHdpZHRoPSI0IiBoZWlnaHQ9IjYiIHg9IjIiIHk9IjE2IiByeD0iMSIgLz4KICA8cGF0aCBkPSJNNCAydjE0IiAvPgogIDxyZWN0IHdpZHRoPSI0IiBoZWlnaHQ9IjYiIHg9IjE4IiB5PSIxNiIgcng9IjEiIC8+CiAgPHBhdGggZD0iTTIwIDJ2MTQiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/rugby
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const rugby: IconNode = [
  [
    'path',
    {
      d: 'M15.7 2.3c-.2-.2-.9-.4-1.7-.3a4.6 4.6 0 0 0-3.7 5.7c.3.2.9.4 1.7.3a4.6 4.6 0 0 0 3.7-5.7',
      key: 'qfa2jo',
    },
  ],
  ['path', { d: 'M20 12H4', key: '1mtusc' }],
  ['rect', { width: '4', height: '6', x: '2', y: '16', rx: '1', key: '1i7j66' }],
  ['path', { d: 'M4 2v14', key: '1wnboq' }],
  ['rect', { width: '4', height: '6', x: '18', y: '16', rx: '1', key: 'dzzpzw' }],
  ['path', { d: 'M20 2v14', key: 'fh206s' }],
];

export default rugby;
